<template>
  <div class="detail-tab-content">
    <div class="title">积分兑换</div>
    <div class="content">
      <wt-form-table :form.sync="form"></wt-form-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GeneralUserViewPointsExchange',
  isAutoComponent: true,
  props: ['id'],
  data() {
    return {
      form: {
        isFormLoading: false,
        formComponent: {
          list: { type: 'default', value: '/modules/userWechat/userWechatExchangeGoodsList', params: { id: 0 }}
        },
        formInputsData: [],
        formButtonsData: [],
        formTableData: [
          { name: '商品编号', key: 'goodsNo', type: 'text' },
          { name: '商品名称', key: 'goodsName', type: 'text' },
          { name: '商品数量', key: 'goodCount', type: 'text' },
          { name: '商品积分', key: 'singleIntegral', type: 'text' },
          { name: '下单时间', key: 'createTime', type: 'text', sortable: 'custom' },
          { name: '兑换时间', key: 'exchangeTime', type: 'text', sortable: 'custom' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '兑换人员', key: 'exchangeUserName', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true, searchButtonHidden: true }
      }
    }
  },
  created() {
    this.form.formComponent.list.params.id = this.id
  }
}
</script>

<style>
</style>
